import React from 'react'
import LiveTVBadge from '../../components/LiveTVBadge'
import fallbackImage from '../../assets/img/fallback-image.webp'

import type { LiveTVHeroProps } from './types'

const DISCLAIMER =
  'These livestreams may follow a different schedule than your on-air broadcast.'
const INFORMATION_UNAVAILABLE = 'Livestream information unavailable'

const LiveTVHero = ({ channel, listing }: LiveTVHeroProps) => {
  const channelLogo = channel?.feed_image?.white_logo
  const altLogo = channelLogo ? `${channel?.short_name} logo` : ''
  const listingImage = listing?.listing_image

  const bgImage = listingImage
    ? `${listing?.listing_image}?resize=1000x644&format=webp`
    : fallbackImage

  return (
    <div className="hero-container">
      <div className="hero-container__info">
        <div className="hero-container__live">
          <LiveTVBadge />
          {channel && (
            <img
              alt={altLogo}
              className="channel-logo"
              src={`${channelLogo}?resize=166x35&format=webp`}
            />
          )}
        </div>
        {channel !== undefined ? (
          <div className="hero-container__information-wrapper">
            <h2 className="hero-container__title">{listing?.show_title}</h2>
            <span className="hero-container__episode">
              {listing?.episode_title}
            </span>
            <p className="hero-container__description">{DISCLAIMER}</p>
          </div>
        ) : (
          <p className="hero-container__title">{INFORMATION_UNAVAILABLE}</p>
        )}
      </div>
      <div className="hero-container__image-wrapper">
        <div
          className="hero-container__image"
          style={{ backgroundImage: `url(${bgImage})` }}
        ></div>
      </div>
    </div>
  )
}

export default LiveTVHero
